import { bool, func, number, shape, string } from "prop-types"
import { Box, Button, StackView, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"
import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import useApiClient from "hooks/use_api_client"
import Icon from "components/planning_center_icon"

const AttendeeSelection = ({ attendeeTypeSelection, canceled, className, withSaveStatus }) => {
  const textColor = canceled ? colors.neutral_500 : colors.neutral_600
  const { registerable, setRegisterable } = useContext(RegisterableContext)
  const api = useApiClient("registrations")

  const handleWaitlistPromotion = () => {
    withSaveStatus(() =>
      api
        .post({
          url: `/registrations/${registerable.id}/promote_waitlist`,
          data: {
            attendee_type_id: attendeeTypeSelection.attendeeTypeId
          }
        })
        .then(response =>
          setRegisterable({ ...registerable, attendeeTypeSelections: response.data })
        )
    )
  }

  const promoteWouldExceedCapacity =
    attendeeTypeSelection.availableCount !== null &&
    attendeeTypeSelection.count > attendeeTypeSelection.availableCount

  const tooltipText =
    "When you promote these attendees, the capacity will be increased automatically."

  return (
    <StackView
      axis="horizontal"
      alignment="center"
      distribution="space-between"
      paddingRight={1}
      spacing={4}
      className={className}
    >
      <StackView axis="horizontal" alignment="flex-start" flexShrink={1} spacing={1}>
        <Text className={canceled ? "t-strike" : null} color={textColor}>
          {attendeeTypeSelection.name}
        </Text>
        {attendeeTypeSelection.waitlist && promoteWouldExceedCapacity && (
          <Box data-tooltip={tooltipText}>
            <Icon
              symbol="general#exclamation-triangle"
              style={{ color: colors.warning }}
              aria-label={tooltipText}
            />
          </Box>
        )}
      </StackView>
      <StackView axis="horizontal" alignment="flex-start">
        {attendeeTypeSelection.waitlist && (
          <Button
            theme="create"
            size="xs"
            variant="outline"
            onClick={handleWaitlistPromotion}
            title="Promote"
          />
        )}
        <Text className={`pl-3 pr-2 ${canceled ? "t-strike" : null}`} color={textColor}>
          {attendeeTypeSelection.count}
        </Text>
      </StackView>
    </StackView>
  )
}

AttendeeSelection.propTypes = {
  attendeeTypeSelection: shape({
    name: string,
    count: number,
    waitlist: bool
  }),
  canceled: bool,
  className: string,
  withSaveStatus: func
}

export default AttendeeSelection
